import { useState } from 'react';
import { SourceRead, TrasparenzaESG } from '../../../../../api/apiTypes';
import { ConfirmValidationDialog } from '../../../../../utils/dialog/ConfirmValidationDialog';
import { cleanContent } from '../../../../../utils/cleanContent';
import Swal from 'sweetalert2';
import { updateTrasparenzaESG, validaTrasparenzaESG } from '../../../../../api/functionApi';
import { useAxiosInterceptor } from '../../../../../api/wrappers';
import { showDialogConfermaModifica } from '../../../../../utils/dialog/showDialogFunction';
import { formatTitle } from '../../../../../utils/Format';
import ElementGenerationsPanel from '../../../ElementGenerationsPanel';
import EventList from '../../../../../utils/EventList';
import SourcesAccordion from '../../../../../components/report/SourcesAccordion';

type ContainerListaDriverPageProps = {
  intermediario: TrasparenzaESG;
  title: string;
  id: string;
  driverId: string;
  intermediarioId: string;
  sources: SourceRead[];
  events: any[];
};

const ContainerTrasparenzaESGDettaglio = ({
  intermediario,
  title,
  id,
  driverId,
  intermediarioId,
  sources,
  events
}: ContainerListaDriverPageProps) => {

  useAxiosInterceptor(); // monta l'interceptor

  const formattedTitle = formatTitle(title);

const [values, setValues] = useState({
  gar_capex_percent: intermediario.value.gar_score.gar_capex_percent ?? 0,
  gar_turnover_percent: intermediario.value.gar_score.gar_turnover_percent ?? 0,
  rating_score: intermediario.value.rating_score?.rating ?? null
});


  const [isEditing, setIsEditing] = useState(false);
  const [showDialogConfermaValidazione, setShowDialogConfermaValidazione] = useState(false);
  const [isIntermediarioValidato, setIsIntermediarioValidato] = useState(intermediario.validation === "validated");

  if (!intermediario) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="w-20 h-20 border-[6px] border-gray-300 border-t-textPrimary rounded-full animate-spin" />
      </div>
    );
  }

  const handleModifica = () => {
    showDialogConfermaModifica(() => setIsEditing(true));
  };

  const handleAnnulla = () => {
    setValues({
        gar_capex_percent: intermediario.value.gar_score.gar_capex_percent ?? 0,
  gar_turnover_percent: intermediario.value.gar_score.gar_turnover_percent ?? 0,
  rating_score: intermediario.value.rating_score?.rating ?? null
    });
    setIsEditing(false);
  };

  const handleSalva = async () => {
const payload = {
  value: {
    gar_score: {
      gar_turnover_percent: values.gar_turnover_percent,
      gar_capex_percent: values.gar_capex_percent
    },
    rating_score: {
      rating: values.rating_score  // solo rating
    }
  }
};



    try {
      await updateTrasparenzaESG(id, driverId, intermediarioId, payload);
      setIsEditing(false);
      setIsIntermediarioValidato(false);
      Swal.fire({
        icon: 'success',
        title: 'Modifica salvata!',
        text: 'Le modifiche sono state salvate correttamente.',
        confirmButtonColor: '#374151',
      });
    } catch (error) {
      console.error('Errore durante il salvataggio:', error);
      Swal.fire({
        icon: 'error',
        title: 'Errore nel salvataggio',
        text: 'Si è verificato un errore durante il salvataggio delle modifiche.',
        confirmButtonColor: '#374151',
      });
    }
  };

  const onClickValida = () => setShowDialogConfermaValidazione(true);

  const handleValidazione = async () => {
    setShowDialogConfermaValidazione(false);

    Swal.fire({
      title: 'Validazione in corso...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => Swal.showLoading()
    });

    try {
      await validaTrasparenzaESG(id, driverId, intermediarioId);
      setIsIntermediarioValidato(true);
      Swal.fire({
        icon: 'success',
        title: 'Validato!',
        text: 'L\'intermediario è stato validato con successo.',
        confirmButtonColor: '#374151',
      });
    } catch (error) {
      console.error('Errore durante la validazione:', error);
      Swal.fire({
        icon: 'error',
        title: 'Errore nella validazione',
        text: 'Si è verificato un errore durante la validazione dell\'intermediario.',
        confirmButtonColor: '#374151',
      });
    }
  };

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-8">
      <h1 className="text-4xl font-bold text-[#1B365D] mb-8">{formattedTitle}</h1>

      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-[#1B365D]">{intermediario.name}</h1>
        <span className="font-medium text-gray-600 text-sm">Score: {intermediario.value.score.total_score}</span>
      </div>

      <div className="mb-8">
        <div className="flex flex-col md:flex-row md:space-x-8 mb-4">
          <div className="w-full md:w-1/2">
            <label className="block text-sm font-medium text-gray-600 mb-1">GAR turnover</label>
            <input
              type="number"
              value={values.gar_turnover_percent}
              readOnly={!isEditing}
              onChange={(e) => isEditing && setValues(prev => ({ ...prev, gar_turnover_percent: Number(e.target.value) }))}
              className={`mt-1 block w-full rounded-md border border-gray-300 focus:border-[#1B365D] focus:ring focus:ring-[#1B365D]/20 p-2 ${isEditing ? "bg-white" : "bg-gray-100"}`}
            />
          </div>

          <div className="w-full md:w-1/2">
            <label className="block text-sm font-medium text-gray-600 mb-1">GAR capex</label>
            <input
              type="number"
              value={values.gar_capex_percent}
              readOnly={!isEditing}
              onChange={(e) => isEditing && setValues(prev => ({ ...prev, gar_capex_percent: Number(e.target.value) }))}
              className={`mt-1 block w-full rounded-md border border-gray-300 focus:border-[#1B365D] focus:ring focus:ring-[#1B365D]/20 p-2 ${isEditing ? "bg-white" : "bg-gray-100"}`}
            />
          </div>

<div className="w-full md:w-1/2">
  <label className="block text-sm font-medium text-gray-600 mb-1">Rating</label>
  <input
    type="number"
    min={0}               // minimo 0
    max={100}             // massimo 100
    step={1}              // passi di 1
    value={values.rating_score ?? ''} // se null, mostra stringa vuota
    readOnly={!isEditing}
    onChange={(e) => {
      if (!isEditing) return;
      let val = Number(e.target.value);
      // limita il valore tra 0 e 100
      if (val < 0) val = 0;
      if (val > 100) val = 100;
      setValues(prev => ({ ...prev, rating_score: val }));
    }}
    className={`mt-1 block w-full rounded-md border border-gray-300 focus:border-[#1B365D] focus:ring focus:ring-[#1B365D]/20 p-2 ${isEditing ? "bg-white" : "bg-gray-100"}`}
  />
</div>

        </div>
      </div>

      {!['approved', 'drafted', 'completed'].includes(intermediario.report_status ?? '') && (
        <div className="flex justify-end space-x-4">
          {!isEditing ? (
            <>
              <button
                onClick={handleModifica}
                className="px-4 py-2 bg-[#1B365D] text-white hover:bg-[#142a4a] rounded-lg"
              >
                Modifica
              </button>
              <button
                onClick={onClickValida}
                disabled={isIntermediarioValidato}
                className={`px-4 py-2 rounded ${isIntermediarioValidato ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'bg-[#1B365D] text-white hover:bg-[#142a4a]'}`}
              >
                Valida
              </button>
            </>
          ) : (
            <>
              <button
                onClick={handleAnnulla}
                className="px-4 py-2 bg-gray-200 text-gray-800 hover:bg-gray-300 rounded"
              >
                Annulla
              </button>
              <button
                onClick={handleSalva}
                className="px-4 py-2 bg-[#1B365D] text-white hover:bg-[#142a4a] rounded-lg"
              >
                Salva
              </button>
            </>
          )}

          {showDialogConfermaValidazione && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
              <div className="bg-white p-6 rounded shadow-lg max-w-sm w-full">
                <ConfirmValidationDialog
                  onConferma={handleValidazione}
                  onAnnulla={() => setShowDialogConfermaValidazione(false)}
                />
              </div>
            </div>
          )}
        </div>
      )}

      {/* Note Dettaglio */}
      <div className="mt-8">
        <div className="bg-gray-50 p-6 rounded-xl border border-gray-100">
          <h2 className="text-xl font-semibold text-[#1B365D] font-semibold mb-3">Frasi rilevanti</h2>
          <ul className="list-none list-inside text-gray-700 leading-relaxed mb-6">
            {intermediario.value?.gar_score?.list_relevant_sentences?.map((frase, index) => (
              <li className="mb-4" key={index}>{cleanContent(frase)}</li>
            ))}
          </ul>
        </div>
      </div>

      <SourcesAccordion sources={sources} reportId={id} componentId={driverId} elementId={intermediarioId} />

      {/* Sezione Attività */}
      <EventList events={events} />
      <ElementGenerationsPanel reportId={id} componentId={driverId} elementId={intermediarioId} />
    </div>
  );
};

export default ContainerTrasparenzaESGDettaglio;
